import { downloadResource } from '@src/api/resources'

export const downloadResourceAssetMixin = {
  methods: {
    async downloadResourceAsset({ resourceId, assetUrl }) {
      try {
        window.open(assetUrl, '_blank')
        await downloadResource({ resourceId: resourceId })
      } catch (err) {
        this.$bvToast.toast('There was a problem downloading this asset. Please try again later', {
          toaster: 'b-toaster-bottom-center',
          toastClass: 'toast-error',
        })
      }
    },
  },
}
